import React from 'react';
import { IconButton } from '@mui/material';
import { NavigateNext } from '@mui/icons-material';

const NextButton = ({ onClick }) => {
  return (
    <IconButton
      onClick={onClick}
      size="medium"
      sx={{
        backgroundColor: '#7d9eb0',
        color: 'white',
        '&:hover': {
          backgroundColor: 'grey.400',
        },
        m: 0.5,
      }}
    >
      <NavigateNext fontSize="medium" />
    </IconButton>
  );
};

export default NextButton;
